const AUTOCOMPLETE_FIX_VALUES = {
  NO_VALUE: 'NO_VALUE',
};

export default AUTOCOMPLETE_FIX_VALUES;
